import React from "react";
import { redirect } from "react-router";

export const loader = () => {
    return redirect("/site-management/settings/date");
};

const SiteManagementIndex = (): React.JSX.Element | undefined => {
    return undefined;
};

export default SiteManagementIndex;
